'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SIZES = exports.TEXT_COLORS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Text;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _SpacerElement = require('../SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'text': 'ccl-19882374e640f487',
  'bold': 'ccl-dd90031787517421',
  'block': 'ccl-9d0a5327c911d0f3',
  'regular': 'ccl-1daa0367dee37c3b',
  'small': 'ccl-417df52a76832172',
  'x-small': 'ccl-1244c6519d4203b3',
  'autoHeight': 'ccl-d20a5732188988de',
  'black': 'ccl-a5fb02a1085896d3',
  'white': 'ccl-1f89da61a98d89af',
  'grey': 'ccl-dfaaa1af6c70149c',
  'light-grey': 'ccl-7e3800ad826d750a',
  'teal': 'ccl-cef9f657adc7a559',
  'green': 'ccl-77427c4c077ca1ab',
  'orange': 'ccl-19b67cf45bdadaf0',
  'red': 'ccl-5e14f096cc1cde7a',
  'berry': 'ccl-e3f2c6db77426269'
};
var TEXT_COLORS = exports.TEXT_COLORS = ['black', 'grey', 'light-grey', 'teal', 'green', 'red', 'orange', 'berry', 'white', 'inherit'];

var TEXT_SIZES = exports.TEXT_SIZES = ['regular', 'small', 'x-small'];

/**
 * This is an internal text component used to
 * implement the <Label>, <Span> and <P> components.
 */
function Text(props) {
  var _classnames;

  var classes = (0, _classnames3.default)(styles.text, styles[props.size], styles[props.color], (_classnames = {}, _defineProperty(_classnames, styles.bold, props.isBold), _defineProperty(_classnames, styles.block, props.isBlock), _defineProperty(_classnames, styles.autoHeight, props.isAutoHeight), _classnames), props.className);

  if (!props.children) {
    return null;
  }

  return _react2.default.createElement(
    _SpacerElement2.default,
    _extends({
      element: props.element,
      spacing: props.spacing,
      className: classes,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing,
      isPlaceholder: props.isPlaceholder,
      placeholderClassName: props.placeholderClassName
    }, props.additionalProps),
    props.children
  );
}

Text.displayName = 'Text';
Text.propTypes = _extends({
  children: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.node, function (props) {
    return !props.isPlaceholder;
  }),
  color: _propTypes2.default.oneOf(TEXT_COLORS),
  size: _propTypes2.default.oneOf(TEXT_SIZES),
  isBold: _propTypes2.default.bool,
  element: _propTypes2.default.string,
  isBlock: _propTypes2.default.bool,
  isAutoHeight: _propTypes2.default.bool,
  additionalProps: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  className: _propTypes2.default.string
}, _SpacerElement2.default.propTypes);

Text.defaultProps = _extends({
  size: 'regular',
  color: 'inherit',
  element: 'p',
  isBold: false,
  isBlock: false,
  isAutoHeight: false,
  additionalProps: {},
  className: undefined
}, _SpacerElement2.default.defaultProps);